import { type Module } from 'vuex'

export interface ISnapshotFiltroValor {
  value: string | number | null
  search?: string | null
}

export interface ISnapshotFiltros {
  filtros: Record<string, ISnapshotFiltroValor>
  pag: number
  limit: number
  savedAt: number
}

export interface StateFiltros {
  snapshots: Record<string, ISnapshotFiltros>
}

const PREFIJO_STORAGE = 'filtros:'

// Hidrata el estado desde sessionStorage para que los snapshots sobrevivan un refresh
function cargarDeSessionStorage(): Record<string, ISnapshotFiltros> {
  const snapshots: Record<string, ISnapshotFiltros> = {}
  try {
    const claves: string[] = []
    for (let i = 0; i < sessionStorage.length; i++) {
      const clave = sessionStorage.key(i)
      if (clave && clave.startsWith(PREFIJO_STORAGE)) claves.push(clave)
    }
    claves.forEach(clave => {
      const raw = sessionStorage.getItem(clave)
      if (!raw) return
      try {
        snapshots[clave.slice(PREFIJO_STORAGE.length)] = JSON.parse(raw)
      } catch {
        sessionStorage.removeItem(clave)
      }
    })
  } catch {
    // ignore storage errors
  }
  return snapshots
}

const filtros: Module<StateFiltros, unknown> = {
  namespaced: true,
  state: (): StateFiltros => ({ snapshots: cargarDeSessionStorage() }),
  mutations: {
    setSnapshot(state: StateFiltros, payload: { key: string; snapshot: ISnapshotFiltros }) {
      state.snapshots[payload.key] = payload.snapshot
      try {
        sessionStorage.setItem(
          PREFIJO_STORAGE + payload.key,
          JSON.stringify(payload.snapshot)
        )
      } catch {
        // ignore storage errors
      }
    },
    clearSnapshot(state: StateFiltros, key: string) {
      delete state.snapshots[key]
      try {
        sessionStorage.removeItem(PREFIJO_STORAGE + key)
      } catch {
        // ignore storage errors
      }
    }
  },
  getters: {
    snapshot: (state: StateFiltros) => (key: string): ISnapshotFiltros | null => {
      return state.snapshots[key] ?? null
    }
  },
  actions: {}
}

export default filtros
